exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 767px) {\n#filtros[data-v-44d54aea] {\n    display: none;\n}\n#filtros.mostar[data-v-44d54aea] {\n    display: block;\n}\n}", ""]);

// exports
